import React, { useEffect, useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  TextField,
} from "@mui/material";
import SaveIcon from "@mui/icons-material/Save";
import CloseIcon from "@mui/icons-material/Close";
import { useFormik } from "formik";
import { useMutation, useQuery } from "react-query";
import { toast } from "react-toastify";

import { locationValidationSchema } from "../../../../utils/validations";
import LocationApi from "../../../../services/Apis/Location.Api";

import dynamicStyle from "./styles";

const initialValues = {
  locationName: "",
  phoneNo: [],
  storeID: "",
};

const DialogForm = (props) => {
  const {
    open,
    setOpen,
    refetchLocations,
    storeID,
    setStoreID,
    locationID,
    setLocationID,
  } = props;

  const classes = dynamicStyle();

  // Get single Location ...
  const { data: singleLocation } = useQuery(
    ["GET_SINGLE_STORE", locationID],
    () => LocationApi.getSingleLocation(locationID),
    {
      enabled: !!locationID,
    }
  );

  const formik = useFormik({
    initialValues: initialValues,
    validationSchema: locationValidationSchema,
    onSubmit: (values) => {
      handleSubmit(values);
    },
  });

  // Set store id on create location ..
  useEffect(() => {
    if (storeID) {
      formik.setFieldValue("storeID", storeID);
    }
  }, [storeID]);

  // Set form fields if update store ..
  useEffect(() => {
    if (singleLocation !== undefined && locationID !== null) {
      formik.setFieldValue("locationName", singleLocation[0]?.locationName);
      formik.setFieldValue("storeID", singleLocation[0]?.storeID);
      formik.setFieldValue("phoneNo", singleLocation[0]?.phoneNo);
    }
  }, [singleLocation]);

  //  Create Tag   ...
  const { mutate: Store, isLoading } = useMutation(
    (body) => {
      if (locationID !== null && singleLocation) {
        return LocationApi.updateLocation(body, locationID);
      } else {
        return LocationApi.createLocation(body);
      }
    },
    {
      onSuccess: (res) => {
        if (res.success) {
          toast.success(res.message);
          refetchLocations();
          handleClose();
        } else {
          toast.error(res.message);
        }
      },
      onError: (error) => toast.error(error.message),
    }
  );

  const handleSubmit = (values) => {
    Store(values);
  };

  const handleClose = () => {
    setOpen(false);
    if (locationID) {
      setLocationID(null);
    }
    formik.resetForm({
      values: {
        locationName: "",
        phoneNo: [],
        storeID: storeID,
      },
    });
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      sx={{
        "& .MuiDialog-container": {
          "& .MuiPaper-root": {
            width: "100%",
            maxWidth: "430px",
          },
        },
      }}
    >
      <DialogTitle className={classes.dialogTitle}>
        {locationID ? "Update Location" : "Add new Location"}
      </DialogTitle>
      <form autoComplete="off" onSubmit={formik.handleSubmit}>
        <DialogContent className={classes.dialogContent}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={12}>
              <TextField
                autoFocus
                type="text"
                margin="dense"
                name="locationName"
                label="Location"
                value={formik.values.locationName}
                onChange={formik.handleChange}
                error={
                  formik.touched.locationName &&
                  Boolean(formik.errors.locationName)
                }
                helperText={
                  formik.touched.locationName && formik.errors.locationName
                }
                fullWidth
                size="small"
              />
            </Grid>
            {/* Phone No Text Box  */}
            <Grid item xs={12} md={12}>
              <TextField
                name="phoneNo"
                label="Phone No"
                fullWidth
                size="small"
                variant="outlined"
                value={formik.values.phoneNo}
                onChange={(event) => {
                  const phoneNos = event.target.value.split(",");
                  formik.setFieldValue("phoneNo", phoneNos);
                }}
                error={formik.touched.phoneNo && Boolean(formik.errors.phoneNo)}
                helperText={
                  (formik.touched.phoneNo && formik.errors.phoneNo) ||
                  "Enter phone numbers separated by commas"
                }
              />
            </Grid>
          </Grid>

          <DialogActions>
            <Button
              className={classes.deleteButton}
              style={{ backgroundColor: "#ed342a", color: "white" }}
              onClick={handleClose}
              variant="contained"
            >
              <CloseIcon fontSize="small" className={classes.iconsStyle} />{" "}
              Cancel
            </Button>
            <Button variant="contained" type="submit">
              <SaveIcon fontSize="small" className={classes.iconsStyle} /> Save
            </Button>
          </DialogActions>
        </DialogContent>
      </form>
    </Dialog>
  );
};

export default DialogForm;
